// AUTO-GENERATED - Do not edit manually
// Run: node scripts/generate-contentful-defaults.mjs --locale=zh-CN to regenerate

export const profileAddtl = {
  profile_section_addtl: {
    contentful_name: 'Profile Section Addtl (DEFAULT DO NOT CHANGE)',
    provider_preferences: {
      contentful_name: '[DEFAULT] Provider Preferences Card',
      name: 'Provider Preferences',
      tooltips: {
        name: {
          text: "A network is a group of doctors and hospitals with which a medical plan has negotiated lower costs. You'll likely pay much less to see an in-network provider than an out-of-network provider.",
          title: 'Provider Preferences',
          underline: 'Provider Preferences',
        },
      },
      yes_label: 'Yes',
      no_label: 'No',
      questions: {
        11: {
          question:
            'If it could save you money, would you be willing to choose a medical plan with fewer in-network doctors and hospitals in your area?',
          tooltip: {
            name: {
              text: 'A narrow network covers fewer providers, but may offer lower premiums. ALEX may still highlight a plan with a narrow network if there are substantial cost savings.',
              title: '',
              underline: 'fewer in-network doctors and hospitals',
            },
          },
        },
        12: {
          question: 'Will you need access to doctors and hospitals outside of your home region?',
          tooltip: {
            name: {
              text: 'A national network covers providers all over the country. This may be important if you travel a lot, work remotely, or are covering a child who lives elsewhere.',
              title: '',
              underline: 'outside of your home region',
            },
          },
        },
        13: {
          question:
            'If it could save you money, would you be willing to choose a plan that requires a referral from your primary care provider before seeing a specialist?',
          tooltip: {
            name: {
              text: "Certain plan types coordinate all care through your primary care provider. This means you'll need to get their recommendation to see a specialist, rather than seeking one out yourself.",
              title: '',
              underline: 'referral from your primary care provider',
            },
          },
        },
      },
    },
    medicare_info_card: {
      contentful_name: '[默认] 医疗保险信息',
      profile_side_panel_header: {
        nodeType: 'document',
        data: {},
        content: [
          {
            nodeType: 'paragraph',
            content: [
              {
                nodeType: 'text',
                value: '想了解医疗保险(Medicare)吗?',
                marks: [
                  {
                    type: 'bold',
                  },
                ],
                data: {},
              },
            ],
            data: {},
          },
        ],
      },
      profile_side_panel_details: {
        nodeType: 'document',
        data: {},
        content: [
          {
            nodeType: 'paragraph',
            content: [
              {
                nodeType: 'text',
                value: 'ALEX可以帮助您或您的亲人选择合适的计划。',
                marks: [],
                data: {},
              },
            ],
            data: {},
          },
        ],
      },
      profile_side_panel_button_text: '访问ALEX医疗保险',
      profile_callout_name: '医疗保险',
      profile_callout_question: '您已经注册Medicare医疗保险了吗?',
      profile_callout_button_options: {
        no: '否',
        yes: '是',
      },
      profile_callout_learn_more:
        '想了解更多关于联邦医疗保险(Medicare)以及如何开始的信息?点击下方按钮在新标签页中打开ALEX Medicare。',
      profile_callout_tooltips: {
        name: {
          text: 'Medicare是一项联邦计划,主要为65岁及以上人群提供健康保险。如果您患有某些残疾或疾病,您可能有资格提前享受该计划。',
          title: 'Medicare',
          underline: 'Medicare',
        },
      },
      text_notes: [
        {
          contentful_name: '[DEFAULT] Medicare Text Note',
          plan_year: '2026',
          short_text: {
            nodeType: 'document',
            data: {},
            content: [
              {
                nodeType: 'paragraph',
                content: [
                  {
                    nodeType: 'text',
                    value: '您提供的内容为空。请提供需要翻译的英文内容,我将为您翻译成简体中文。',
                    marks: [],
                    data: {},
                  },
                ],
                data: {},
              },
            ],
          },
          long_text: {
            nodeType: 'document',
            data: {},
            content: [
              {
                nodeType: 'paragraph',
                content: [
                  {
                    nodeType: 'text',
                    value: '您提供的内容为空。请提供需要翻译的英文内容,我将为您翻译成简体中文。',
                    marks: [],
                    data: {},
                  },
                ],
                data: {},
              },
            ],
          },
          button_text: '阅读更多',
        },
      ],
    },
  },
};
